<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('dw.report.lifePolicy.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-btn @click="exportReport" variant="success"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="searchTable" keywordPlaceholder="Type to Search" searchAction="getLifePolicyReport" vuexModule="Dw" type="life" :filters="filters" :columns="columns" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard, FITModal, FITAlert, FITTextInput, FITDatePicker } from '@/components'
import Vue from 'vue'
import { domain } from '@/api/api.js'
import { saveAs } from 'file-saver/FileSaver';
import { mapGetters } from 'vuex'
export default {
  name: 'ReportLifePolicy',
  components: {
    FITSearchableTable,
    FITFormCard,
    FITModal,
    FITAlert,
    FITTextInput,
    FITDatePicker
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportLifePolicyReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);
      })
    },
    generateCommStatusDom(status, translatedStatus) {
      let icon = '';
      let text = 'danger';
      switch (status.toLowerCase()) {
        case 'p':
          icon = 'fa-check'
          text = 'success'
          break;
        case 'u':
          icon = 'fa-times-circle'
          text = 'danger'
          break;
      }
      return `<span class="text-${text}"><i class="fa ${icon} mr-2"></i>${translatedStatus}</span>`;
    },
    onClickModal(evt) {
      if (!evt) {
        return;
      }
      let params = {
        ID: this.seletedRow.ID,
        ...this.payCommForm,
      }
      this.$store.dispatch('Adm/payCompanyCommission', params).then((json) => {
        this.$refs.searchTable.search();
        this.$refs.alert.showAlert()
        Vue.set(this, 'payCommForm', {
          commissionDate: '',
          commissionActualReceived: ''
        });
        this.$refs.confirmCommissionModal.closeModal();

      }).catch((err) => {
        console.error(err);
      })
    },
    onRowSelected(row) {
      Vue.set(this, 'seletedRow', row);
      this.$refs.confirmCommissionModal.openModal();
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Dw', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    setCurrentFilters(val) {
      Vue.set(this, 'currentFilters', val);
      console.debug(val);
    },
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  data() {
    return {
      alertParams: {
        content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`,
        variant: 'success'
      },
      seletedRow: {},
      payCommForm: {
        commissionDate: '',
        commissionActualReceived: ''
      },

      currentFilters: {},
      filters: [{
        label: this.$t('dw.general.status'),
        key: 'policyStatus',
        type: 'select',
        default: null,
        haveAll: true,
      }, {
        label: this.$t('dw.general.workFlowStep'),
        key: 'workFlowStep',
        type: 'select',
        default: null,
        haveAll: true,
      }, ],
      columns: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          thClass: ['tableMinWidth120'],
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'policyReference',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyReference'),
          thClass: ['tableMinWidth120'],
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'englishNamePolicyOwner',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyOwner'),
          formatter: (row, key, item) => {
            return '<div>' + this.$options.filters.isEmpty(item.englishNamePolicyOwner) + '</div>' +
              '<div>' + this.$options.filters.isEmpty(item.chineseNamePolicyCustomer) + '</div>'
          }
        },
        {
          key: 'agentEnglishName',
          label: this.$t('osm.contents.lifePolicy.generalInformation.currentAgent'),
          formatter: (row, key, item) => {
            return '<div>' + this.$options.filters.isEmpty(item.agentEnglishName) + '</div>' + '<div>' + this.$options.filters.isEmpty(item.agentChineseName) + '</div>'
          }
        },
        {
          key: 'workFlowStep',
          label: this.$t('osm.contents.lifePolicy.generalInformation.workFlowStep'),
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'policyStatus',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyStatus'),
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
      ],
    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: default !important;
}

</style>



// WEBPACK FOOTER //
// src/Dw/containers/ReportLifePolicy.vue